import React, {useEffect} from 'react'
import {connect} from 'react-redux'
import {push, goBack} from "connected-react-router"
import {Link} from "react-router-dom"
import {useTranslation} from 'react-i18next'

import AuthActions from './LoginPage/reducer'

import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import AppleSignin from 'react-apple-signin-auth'
import { useGoogleLogin } from '@react-oauth/google';

import {Layout, Card, Spin, Button} from 'antd'

import SignUpEmailForm from '../Components/Forms/SignUpEmailForm'
import AddEmailForm from '../Components/Forms/AddEmailForm'
import ButtonComponent from "../Components/Button";
import LoginHeader from '../Components/LoginHeader'
import Images from '../Images'

function SignUpPage(props) {

  const {match, error, fetching} = props

  const {path} = match

  const {t} = useTranslation()

  function handleSubmit(data) {
    props.checkEmail(data)
  }

  const responseFacebook = (response) => {
    console.log('responseFacebook', response)
    if (response && response.accessToken) {
      props.socialAuth(response.accessToken, 'facebook')
    }
  }

  const responseGoogle = useGoogleLogin({
    onSuccess: (response) => {
      console.log('google onSuccess response', response);
      if (response && response?.access_token) {
        props.socialAuth(response?.access_token, 'google');
      }
    },
    onFailure: (response) => {
      console.log('google onFailure response', response);
      if (response && response?.access_token) {
        props.socialAuth(response?.access_token, 'google');
      }
    }
  });

  const responseApple = (response) => {
    console.log('responseApple', response)
    if (response && response.authorization) {
      if (response.user) {
        props.socialAuth(response.authorization.id_token, 'apple', response.user)
      } else {
        props.socialAuth(response.authorization.id_token, 'apple')
      }
    }
  }

  useEffect(() => {
    document.title = 'Sign Up - In_Home'
  }, [])

  useEffect(() => {
    if (error) {
      props.resetError()
    }

  }, [error])

  return (
    <Layout>
      <Spin size="large" spinning={fetching} wrapperClassName='full-screen'>
        <div className="login-row">
          <LoginHeader/>
          <div className="login-content">

            <div className="content-main sign-up">
              {
                path === "/add-email"
                  ? (
                    <Card className="login-card" style={{minHeight: '208px'}}>
                      <h2 className="card-title">{t('Enter Your Email')}</h2>
                      <AddEmailForm
                        onSubmit={handleSubmit}
                        error={error?.message}
                      />

                    </Card>)
                  : (
                    <Card className="login-card">
                      <h2 className="card-title">{t('Create an Account')}</h2>
                      <SignUpEmailForm
                        onSubmit={handleSubmit}
                        error={error?.message}
                      >
                        <div className="social-title" style={{margin: '16px 0'}}>
                          <div className="middle-line"/>
                          <span style={{fontSize: 12, margin: '0 16px'}}>{t('Sign Up With')}</span>
                          <div className="middle-line"/>
                        </div>
                        <div className="social-btn-block">

                          <ButtonComponent
                            className="btn-primary"
                            type="primary white"
                            onClick={responseGoogle}
                          >
                            <img
                              className="btn-icon icon-space"
                              src={Images.google}
                              alt=""
                            />
                            Google
                          </ButtonComponent>

                          <FacebookLogin
                            appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                            scope="public_profile,email"
                            textButton
                            cssClass="my-social-btn"
                            callback={responseFacebook}
                            disableMobileRedirect={true}
                            render={renderProps => (
                              <Button className="btn-primary" type="primary white" onClick={renderProps.onClick}>
                                <img className="btn-icon icon-space" src={Images.facebook} alt=""/>
                                Facebook
                              </Button>
                            )}
                          />

                          <AppleSignin
                            authOptions={{
                              clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
                              scope: 'email name',
                              redirectURI: process.env.REACT_APP_BASE_URI + '/sign-up',
                              state: 'state',
                              nonce: 'nonce',
                              usePopup: true,
                            }}
                            className="apple-auth-btn"
                            noDefaultStyle={false}
                            onSuccess={responseApple}
                            onError={responseApple}
                            skipScript={false}
                            render={renderProps => (
                              <Button className="btn-primary" type="primary white" onClick={renderProps.onClick}>
                                <img className="btn-icon icon-space" src={Images.apple} alt=""/>
                                Apple
                              </Button>
                            )}
                          />

                        </div>
                        <div className="sign-up-link">
                          {t('Already have an account?')} <Link to="/login">{t('Sign In')}</Link>
                        </div>
                      </SignUpEmailForm>

                    </Card>)
              }
            </div>
          </div>
        </div>
      </Spin>
    </Layout>
  )
}

const mapStateToProps = (state) => {
  return {
    error: state.auth.error,
    fetching: state.auth.fetching,
  }
}

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = (dispatch) => ({
  navPush: (path, state) => dispatch(push(path, state)),
  navGoBack: () => dispatch(goBack()),
  checkEmail: (data) => dispatch(AuthActions.checkEmailRequest(data)),
  resetError: () => dispatch(AuthActions.authErrorReset()),
  socialAuth: (accessToken, type, user) => dispatch(AuthActions.socialAuthRequest(accessToken, type, user)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SignUpPage)
